import React, { useMemo } from 'react';
import { Card, Typography, Space, Button, Input } from 'antd';
import { normalizeBase } from '@digiwedge/ui-health-panels';

export interface PortalLoginFlowDiagnosticsPanelProps {
  idpBase: string;
  audience: string;
  redirectUri?: string;
}

export default function PortalLoginFlowDiagnosticsPanel({
  idpBase,
  audience,
  redirectUri,
}: PortalLoginFlowDiagnosticsPanelProps): React.ReactElement {
  const { Text } = Typography;
  const base = useMemo(() => normalizeBase(idpBase), [idpBase]);
  const origin = useMemo(() => {
    try {
      return window.location.origin;
    } catch {
      return '';
    }
  }, []);
  const redir = redirectUri || (origin ? `${origin}/auth/callback` : '');

  const authorizeUrl = base
    ? `${base}/api/auth/authorize?audience=${encodeURIComponent(audience)}&redirect_uri=${encodeURIComponent(
        redir,
      )}`
    : '';

  return (
    <Card title="Portal Auth Flow Helpers">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Text type="secondary">
          Constructs URLs used by the portal login flow to help debug redirects.
        </Text>
        <Space>
          <Text strong>Authorize URL</Text>
          <Input readOnly value={authorizeUrl} />
          <Button
            disabled={!authorizeUrl}
            onClick={() => window.open(authorizeUrl, '_blank', 'noopener')}
          >
            Open
          </Button>
        </Space>
        <Space>
          <Text strong>Redirect URI</Text>
          <Input readOnly value={redir} />
        </Space>
      </Space>
    </Card>
  );
}
